(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-gate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__tbGateInit) return;
    window.__tbGateInit = true;

    function sha256(str) {
      if (!window.crypto || !crypto.subtle) return Promise.reject(new Error('nocrypto'));
      return crypto.subtle.digest('SHA-256', new TextEncoder().encode(str)).then(function (buf) {
        return Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
      });
    }
    function unlock(hex) {
      try { localStorage.setItem('tb-gate-ok', hex); } catch (e) {}
      try { document.cookie = 'forider_ea_code=' + hex + '; path=/; max-age=' + (60 * 60 * 24 * 30) + '; samesite=lax'; } catch (e) {}
      document.documentElement.setAttribute('data-tb-gate', 'open');
      window.scrollTo(0, 0);
    }
    function attempt(form, raw) {
      var root = form.closest('[data-tb-gate-root]');
      var val = String(raw || '').trim().toUpperCase().replace(/\s+/g, '');
      var hashes = ((root && root.dataset.hashes) || '').split(',').filter(Boolean);
      var err = form.querySelector('.tb-gate__err');
      var input = form.querySelector('input[name="code"]');
      var fail = function () {
        if (err) err.hidden = false;
        if (input) input.setAttribute('aria-invalid', 'true');
        form.classList.remove('is-shake'); void form.offsetWidth; form.classList.add('is-shake');
      };
      if (!val || !hashes.length) return fail();
      sha256(val).then(function (hex) {
        if (hashes.indexOf(hex) > -1) unlock(hex); else fail();
      }, fail);
    }

    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest && e.target.closest('[data-tb-gate-form]');
      if (!form) return;
      e.preventDefault();
      var input = form.querySelector('input[name="code"]');
      attempt(form, input && input.value);
    });
    document.addEventListener('input', function (e) {
      var input = e.target && e.target.closest && e.target.closest('[data-tb-gate-form] input');
      if (!input) return;
      input.removeAttribute('aria-invalid');
      var err = input.closest('form').querySelector('.tb-gate__err');
      if (err) err.hidden = true;
    });
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-tb-gate-join]');
      if (!btn) return;
      var box = document.getElementById(btn.getAttribute('aria-controls'));
      if (!box) return;
      var open = box.hidden;
      box.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      if (open) { var i = box.querySelector('input[type="email"]'); if (i) i.focus(); }
    });
    document.addEventListener('tb:countdown-end', function (e) {
      var root = e.target.closest && e.target.closest('[data-tb-gate-root]');
      if (root && root.dataset.tbGateUnlockAtZero === 'true') {
        document.documentElement.setAttribute('data-tb-gate', 'open');
      }
    });
    document.addEventListener('DOMContentLoaded', function () {
      if (location.search.indexOf('customer_posted=true') > -1) {
        var jb = document.querySelector('[data-tb-gate-join]');
        if (jb) jb.click();
      }
      var q = new URLSearchParams(location.search).get('codigo');
      var form = document.querySelector('[data-tb-gate-form]');
      if (q && form && document.documentElement.getAttribute('data-tb-gate') === 'locked') {
        var input = form.querySelector('input[name="code"]');
        if (input) input.value = q;
        attempt(form, q);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
